import styles from "./ResultsList.module.css";
import highlighter from "../../utils/highliter";

const DropInfo = ({ open, content, searchKey }) => {
  let itemCount = 0;
  return (
    <div
      className={styles["cpv-search-dropperWraper"]}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className={
          styles["cpv-search-dropContent"] +
          " " +
          (open ? styles["cpv-search-dropContentOpen"] : "")
        }
      >
        {Object.keys(content)
          .filter(
            (key) =>
              (key === "hinweise" || key === "synonyme") &&
              content[key]?.length > 0
          )
          .map((key) => {
            itemCount++;
            return (
              <div key={key}>
                {itemCount > 1 && <br />}
                <strong>{key}</strong>
                <br />
                <span
                  dangerouslySetInnerHTML={{
                    __html: highlighter(searchKey, content[key]),
                  }}
                />
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default DropInfo;
